// extracted by mini-css-extract-plugin
export default {"suggestionButton":"SuggestionCard-module__suggestionButton--iIJT3","icon":"SuggestionCard-module__icon--he8bn"};